import Decimal from 'decimal.js';
import compact from 'lodash/compact';

const formatNumber = ({ number, decimalPlaces }) => {
  if (number === undefined) {
    return '';
  }
  const decimal = new Decimal(number);
  const numberAsString = decimalPlaces !== undefined ? decimal.toFixed(decimalPlaces) : decimal.toString();
  const parts = numberAsString.split('.');
  return compact([parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), parts[1]]).join('.');
};

export default formatNumber;
